
import Link from "next/link";
import { useState } from "react";
import { setSubscribeEmailToNewsletter } from "../../../api/subscribeEmailToNewsletter";
import CertificatesShow from "../../CertificatesShow";
import CustomSnackbar, { CustomSnackbarType } from "../../customSnackbar";



const usefullLinks = [
  {
    title: "تماس با ما",
    href: "/pages/contact"
  },

  {
    title: "قوانین و مقررات",
    href: "#"
  },
  {
    title: "دربارهٔ ما",
    href: "#"
  },
  {
    title: " راهنمای خرید",
    href: "#"
  },
]



// eslint-disable-next-line import/no-default-export
export default function TopFooterSection() {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [severity, setSeverity] = useState<CustomSnackbarType['severity']>('success')

  const [customerEmail, setCustomerEmail] = useState('');
  const handelSubscribeEmail = async (email: string) => {
    setLoading(true);
    setSeverity('success');
    setMessage('لطفا کمی صبر کنید ...')
    const result = await setSubscribeEmailToNewsletter(email);
    setLoading(false);

    if (result?.errors) {
      setMessage(result?.errors[0]?.message as string);
      setSeverity('error');
      setShow(true);

    } else {
      setMessage("ایمیل شما با موفقیت افزوده شد")
      setShow(true)
      setSeverity('success')
    }
  }

  return (<>
    {show && <CustomSnackbar
      message={message}
      onClose={() => setShow(false)}
      severity={severity}
    />}
    <div className="flex flex-wrap gap-3 justify-center">
      <div className="flex flex-col gap-3  w-full md:max-w-[150px]">
        <h3 className="text-sm font-bold text-black hidden md:block">
          دسترسی سریع        </h3>

        <ul className="flex flex-row gap-2 md:gap-1 md:flex-col justify-center">
          {usefullLinks.map((item) => (
            <li key={item.title} className="w-full pb-2">
              <Link href={item.href ?? "#"} className="text-sm transition-colors hover:text-black">
                {item.title}
              </Link>
            </li>
          ))}
        </ul>

      </div>

      <div className="max-w-[600px] w-full">
        <h3 className="text-sm font-bold text-black">

          درباره رایان کامرس
        </h3>
        <br />
        گروه رایان کامرس از سال 1390 فعالیت خود را در زمینه طراحی و توسعه نرم افزارهای تحت وب با توجه به استانداردها و متدولوژی های روز دنیا و مد نظر قرار دادن ارزش ها و باورهای حرفه ای و نیز مطالعات کیفی و کمی در زمینه سیستم های یکپارچه مدیریت تحت وب , به منظور طرح,توسعه کاربرد نرم افزارهای مبتنی بر وب اغاز نمود.

        <br />
        شرکت طراحی سایت رایان کامرس با طراحی چندین سایت اینترنتی در زمینه های طراحی سایت با بهره گیری از بروزترین تکنولوژی های طراحی سایت ، سئو و بهینه سازی سایت با افتخار در کنار شماست.
      </div>
      <CertificatesShow />
      <div className="max-w-[400px] w-full">
        <h3 className="text-sm font-bold text-black border-[2px] border-solid border-[#343434] border-x-0 border-t-0">
          تازه‌ترین مطالب در ایمیل شما
        </h3>
        <div className="pt-3 flex flex-col justify-between">
          <p className="text-sm">
            با اشتراک در خبرنامه ما از آخرین تخفیف‌ها، فروش‌های ویژه و بسیاری مطالب دیگر مطلع شوید
          </p>

          <div className="flex justify-between h-8 mt-5 rounded-sm">
            <input type="email" className="h-full text-center text-white border border-solid border-default-100 p-[1px] text-sm border-l-0 outline-none shadow-none bg-default-900 flex-1"
              value={customerEmail}
              onChange={(e) => setCustomerEmail(e.target.value)}
            />
            <button disabled={loading} className="bg-primary-500 text-white text-sm font-light px-2"
              onClick={() => handelSubscribeEmail(customerEmail)}
            >مشترک شوید!</button>
          </div>
          <p className={`w-full text-xs ${severity === 'error' ? 'text-red-600' : 'text-green-500'}`}>{message}</p>
        </div>
      </div>
    </div>
  </>

  )
}